<template>
<div class="container">
    <div class="nav">
      <Btnav></Btnav>  
    </div>

  
    <div class="banner" :style=" 'background-image: url(' + this.banner + ');background-size: cover;'">
      <div class="banner-text">
        <div>{{bannertext1}}</div>
      </div>
    </div>

    <div class="newsCenter">
       <div class="father" v-for="(item,index) in this.newarray" :key="index" @click="routerdetails(item.id)">
           <img :src="item.image[0]" alt="">
           <div class="all">
               <p class="title">{{ischinese == "cn" ?item.title:item.title_en}}</p>
               <p class="content" style=" -webkit-box-orient: vertical;">{{ischinese == "cn" ?item.introduce:item.introduce_en}}</p>
              <p class="time">{{item.time}}</p>
           </div>
           
       </div>
    </div>
    <!-- 分页 -->
    <div class="block">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageSize"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total = total>
        </el-pagination>
    </div>

     <Btfooter></Btfooter>
  </div>
</template>
<script>
import Btnav from '../../components/dashu/nav';
import Btfooter from '../../components/dashu/footer';
export default {
  components:{Btnav,Btfooter},
  data(){
    return{
      banner:'',
      current: 5,
      pageSize: 1,
      total:0,
      ischinese: "cn",
      bannertext1: "新闻中心",
      newarray:[]
    }
  },
  created(){  
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.bannertext1 = "Information Center";
    }
    this.getCaseModuleList()
  },
  methods:{
      handleSizeChange(val) {
        // console.log(`每页每页每页 ${val} 条handleSizeChange`);
        this.current = val
        this.getCaseModuleList()
      },
      handleCurrentChange(pagesize) {
        // console.log(pagesize,"handleCurrentChange");
       this.pageSize = pagesize
       this.getCaseModuleList()
       document.documentElement.scrollTop = '600'
       document.body.scrollTop = '600'
      },
      routerdetails(detailsid) {
       this.$router.push({
        name: 'Anews',
        query: { detailsid: detailsid }
        })
      }, 
      getCaseModuleList() {
      this.$http
        .post('/api/dashu/news/newsList', {
          noPaginate: 1,
          page: this.pageSize,
          pageSize: this.current
        })
        .then(res => {
          if (res.data.code === 0) {
             this.banner = res.data.data.banner.image
            const setting = res.data.data
            this.newarray = setting.lists
            this.total = setting.total
            // console.log(this.newarray)
          }
        })
    },  
  }
}
</script>
<style scoped>
body{
  position: relative;
}
.container{
 background-color:white;
 min-width: max-content;
 min-width: -moz-max-content;
}
.nav{
  overflow: hidden !important;
}
.nav{
  position: absolute;
  top:0;
  z-index: 10;
  width: 100%;
  min-width: 1200px;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
}
.banner{
  overflow: hidden !important;
  position: relative;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 607px;
  /* margin-top: 57px; */
}
.block{
    overflow: hidden !important;
    position: relative;
    width:1200px;
    /* height: 654px; */
    margin: 20px auto 50px;
    text-align: center;
}
.newsCenter{
  overflow: hidden !important;
  position: relative;
  width:1200px;
  /* height: 654px; */
  margin: 140px auto 50px;
  /* text-align: center; */
} 
.newsCenter .father{
   display: flex;
   margin-top: 60px;
   cursor: pointer;
}
.newsCenter .father:nth-child(1){
   display: flex;
   margin-top: 0px;
}
.newsCenter .all{
   position: relative;
   height: 250px;
   margin-left:40px; 
}
.newsCenter img{
    width: 405px;
    height: 250px;
}
.newsCenter .title{
    font-size: 30px;
    color: #333;
    font-weight: bold;
    margin: 0;
}
.newsCenter .content{
    font-size: 16px;
    line-height: 30px;
    color: #888888;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:2;
    /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
    margin-top: 30px; 
}
.newsCenter .time{
    position: absolute;
    font-size: 12px;
    color: #888888;
    bottom: 0;
    margin: 0;
    width: 200px;
}
.banner-text {
  width: 100%;
  text-align: center;
  font-size: 70.34px;
  color: #ffffff;
  padding-top: 125px;
}
.banner-text div {
  width: 700px;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/pcPages/Anew.vue